import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo_pos.svg'


const _withScopeId = n => (_pushScopeId("data-v-235f1e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  class: "logo"
}, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "button-container"
}

import { computed } from 'vue'
import { useDisplay } from 'vuetify'
import { themedSettings } from '@/plugins/vuetify'
import { useAuthStore } from '@/stores/authStore'
import { NavigationItem } from '@/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'header-appBar',
  props: {
  navigationItems: Array as () => NavigationItem[],
  drawer: Boolean
},
  emits: ['update:drawer'],
  setup(__props, { emit: __emit }) {

const AuthStore = useAuthStore()
const display = useDisplay()

const props = __props
const emit = __emit

const getHeaderWidth = computed(() => {
  return display.width
})

const toggleDrawer = () => {
  emit('update:drawer', !props.drawer)
}

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    app: "",
    flat: "",
    absolute: "",
    color: "primary",
    density: "compact",
    height: "100",
    class: _normalizeClass(
      getHeaderWidth.value.value <= _unref(themedSettings).isMobileViewWidth
        ? 'xpadding-mobile'
        : getHeaderWidth.value.value < _unref(themedSettings).maxWidth
        ? 'xpadding-other'
        : 'xpadding-responsive'
    )
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_v_spacer),
      (
        _unref(AuthStore).isAuthenticated &&
        getHeaderWidth.value.value > _unref(themedSettings).isMobileViewWidth
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navigationItems, (item) => {
              return (_openBlock(), _createBlock(_component_v_toolbar_items, {
                key: item.title,
                link: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: item.href
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        flat: "",
                        class: "pa-4 rounded custom-button",
                        color: "btnPrimary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (getHeaderWidth.value.value <= _unref(themedSettings).isMobileViewWidth && _unref(AuthStore).isAuthenticated)
        ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
            key: 1,
            onClick: toggleDrawer
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})